import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 2rem 0 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const DirectoryItemsContainer = styled.div`
    margin-top: 1rem;
    padding: 0 1rem 2rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem 2rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 0 2rem;
    }
`
